module.exports = __webpack_public_path__ + "img/latitude-standard-logo-blue.b66493c8.svg";